class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.beobachteHinzufuegen();
  }

  /*
   * Automatisch oeffnen, wenn irgendetwas in den Warenkorb gelegt wird.
   *
   * Legt das Theme selbst etwas hinein, oeffnet product-form.js den Drawer ueber
   * renderContents(). Legt dagegen eine App wie Globo etwas hinein, laeuft dieser
   * Weg nicht - der Warenkorb fuellt sich, aber nichts oeffnet sich.
   *
   * Die Zaehlerblase zu beobachten funktioniert nicht: cart-icon-bubble.liquid
   * rendert .cart-count-bubble nur innerhalb von {%- if cart != empty -%}. Bei
   * leerem Warenkorb existiert das Element beim Seitenaufruf gar nicht - genau
   * der Fall, in dem das Oeffnen gebraucht wird.
   *
   * Stattdessen wird der Netzverkehr beobachtet. Jede Anfrage an /cart/add
   * oeffnet den Drawer, unabhaengig davon, wer sie ausloest.
   */
  beobachteHinzufuegen() {
    const drawer = this;

    const istHinzufuegen = function (url) {
      return /\/cart\/add(\.js)?(\?|$)/.test(String(url || "").split("#")[0]);
    };

    // Kurze Verzoegerung: Shopify muss den Warenkorb erst serverseitig fertig
    // schreiben, sonst holt open() noch den alten Stand.
    const danach = function () {
      drawer._wurdeHinzugefuegt = true;
      window.setTimeout(function () {
        drawer.open();
      }, 120);
    };

    // Wichtig: window.fetch muss mit window als Empfaenger aufgerufen werden.
    // Ein Klassenrumpf laeuft im strict mode - ruft eine App schlicht fetch(...)
    // auf, ist this dort undefined, und fetch wirft dann "Illegal invocation".
    // Das wuerde jeden fetch-Aufruf der Seite toeten, nicht nur den zum Warenkorb.
    //
    // Ausserdem wird der urspruengliche Aufruf immer zuerst und ausserhalb des
    // try ausgefuehrt. Selbst wenn hier alles schiefgeht, ist die Anfrage der
    // App davon unberuehrt - schlimmstenfalls oeffnet der Drawer nicht.
    const urspruenglichesFetch = window.fetch;
    if (typeof urspruenglichesFetch === "function") {
      window.fetch = function () {
        const ergebnis = urspruenglichesFetch.apply(window, arguments);

        try {
          const eingabe = arguments[0];
          const url =
            typeof eingabe === "string"
              ? eingabe
              : (eingabe && eingabe.url) || "";

          if (istHinzufuegen(url) && ergebnis && typeof ergebnis.then === "function") {
            ergebnis.then(danach, function () {});
          }
        } catch (e) {
          // Beobachten ist Beiwerk. Fehler hier duerfen die Anfrage nicht stoeren.
        }

        return ergebnis;
      };
    }

    const urspruenglichesOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (methode, url) {
      try {
        this._lxWarenkorbUrl = url;
      } catch (e) {}
      return urspruenglichesOpen.apply(this, arguments);
    };

    const urspruenglichesSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      try {
        if (istHinzufuegen(this._lxWarenkorbUrl)) {
          this.addEventListener("load", danach);
        }
      } catch (e) {}
      return urspruenglichesSend.apply(this, arguments);
    };
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  /*
   * Inhalt beim Oeffnen auffrischen.
   *
   * Der Drawer wird sonst nur neu gezeichnet, wenn eine theme-eigene Komponente
   * publish(PUB_SUB_EVENTS.cartUpdate, ...) ausloest. Das ist ein internes
   * Signal aus assets/pubsub.js - externe Apps koennen es nicht ausloesen.
   * Legt eine App wie Globo einen Artikel hinein, zeigt der Drawer weiter den
   * alten Stand, oft die Leeransicht.
   *
   * Drawer und Warenkorbsymbol kommen ueber die Section Rendering API in einer
   * einzigen Anfrage. Ersetzt wird nur, was sich tatsaechlich unterscheidet.
   */
  async auffrischen() {
    if (this._frischtAuf) return;
    this._frischtAuf = true;

    try {
      const antwort = await fetch(
        `${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`
      );
      const daten = await antwort.json();

      if (daten["cart-drawer"]) {
        const html = new DOMParser().parseFromString(
          daten["cart-drawer"],
          "text/html"
        );

        const quelle = html.querySelector("#CartDrawer");
        const ziel = this.querySelector("#CartDrawer");

        if (quelle && ziel && quelle.innerHTML.trim() !== ziel.innerHTML.trim()) {
          ziel.innerHTML = quelle.innerHTML;

          // Leer-Zustand mitfuehren, sonst blendet component-cart-drawer.css
          // den Kopfbereich weiter aus und zeigt die Leeransicht.
          const gerendert = html.querySelector("cart-drawer");
          if (gerendert) {
            this.classList.toggle(
              "is-empty",
              gerendert.classList.contains("is-empty")
            );
          }

          // Die Verknuepfung des Overlays haengt am ersetzten Knoten.
          const overlay = this.querySelector("#CartDrawer-Overlay");
          if (overlay) overlay.addEventListener("click", this.close.bind(this));
        }
      }

      if (daten["cart-icon-bubble"]) {
        const zielBlase = document.getElementById("cart-icon-bubble");

        if (zielBlase) {
          const html = new DOMParser().parseFromString(
            daten["cart-icon-bubble"],
            "text/html"
          );
          const abschnitt = html.querySelector(".shopify-section");

          if (abschnitt && abschnitt.innerHTML.trim() !== zielBlase.innerHTML.trim()) {
            zielBlase.innerHTML = abschnitt.innerHTML;
          }
        }
      }
    } catch (e) {
      // Auffrischen ist eine Verbesserung, kein Muss. Bei Fehlern bleibt der
      // bisherige Inhalt stehen.
    }

    this._frischtAuf = false;
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.auffrischen();
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
      const cartDrawerItems = this.querySelector("cart-drawer-items");
      if (cartDrawerItems) {
        cartDrawerItems.updateCartUpsellToggleState();
        cartDrawerItems.updateCartUpsellVisibility();
      }
      // Dispatch cart:open event
      document.dispatchEvent(new CustomEvent('cart:open'));
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");

    /*
     * Globo baut seine Preisberechnung nur beim Seitenaufruf auf. Wurde auf
     * dieser Seite schon etwas hinzugefuegt, laesst sich zwar weiter klicken,
     * die Anzeige rechnet bei einer zweiten Konfiguration aber nicht mehr mit.
     *
     * Beim Schliessen des Drawers wird deshalb neu geladen - aber nur, wenn
     * wirklich etwas hinzugefuegt wurde und wir auf einer Produktseite sind.
     * Auf allen anderen Seiten und beim blossen Hineinschauen passiert nichts.
     */
    if (this._wurdeHinzugefuegt && document.querySelector("product-form")) {
      window.location.reload();
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);